import { ColumnDef } from '@tanstack/react-table'

import { Tooltip, TooltipContent, TooltipTrigger } from '@hap/components'
import { startCase } from '@hap/utils'

import { MakeColumnOptions } from './types'

interface Props<D extends UnknownRecord> extends MakeColumnOptions<D> {
  weight?: 'medium' | 'bold'
}

export function makeColumnV2<D extends UnknownRecord>({
  align = 'left',
  fieldKey,
  header = startCase(fieldKey.toString()),
  sortable,
  sticky,
  width,
  minWidth = width,
  maxWidth,
  footer,
}: Props<D>): ColumnDef<D> {
  return {
    accessorKey: fieldKey,
    id: fieldKey as string,
    header,
    size: width,
    minSize: minWidth,
    maxSize: maxWidth,
    enableSorting: sortable,
    meta: { align, sticky },
    footer: footer,
    cell: (cell) => {
      const value = cell.getValue<string | string[]>()
      return (
        <Tooltip delayDuration={100}>
          <TooltipTrigger asChild>
            <span className="truncate whitespace-nowrap">{value}</span>
          </TooltipTrigger>

          <TooltipContent className="h-auto max-w-prose overflow-visible whitespace-normal">
            <div className="space-y-4">
              {Array.isArray(value) ? value.map((v, i) => <p key={i}>{v}</p>) : value}
            </div>
          </TooltipContent>
        </Tooltip>
      )
    },
  }
}
